import { DataSource } from './abstract-data-source';
import { AbstractDataSourceType } from './abstract-data-source-type';
import {IHive} from "@/contracts/HiveContract";

export interface HiveDataType extends AbstractDataSourceType, IHive {

}

export class HivesDataSource extends DataSource {
    public data: HiveDataType[];

    constructor(hives: IHive[]) {
        super(hives);
    }
}
